export default __webpack_public_path__ + "static/media/47.ffb71fc7.jpeg";